import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonLinkWithIcon } from '@blueprint/ui';
import { Button } from 'new-homes/components/DevelopmentDetails/DevelopmentDetails.styles';

const SectionMarginTop = '96px';

export const SearchSuggestionsTownsAndCitiesWrapper = styled.div(
    () =>
        css`
            width: 100%;
            height: auto;
            background-color: #fff;
            margin: ${SectionMarginTop} 0;
            display: block;
            justify-content: space-between;
            position: relative;
        `
);

export const TownsAndCitiesHeadlineWrapper = styled.div(
    () =>
        css`
            width: 100%;
            display: flex;
            justify-content: space-between;
            z-index: -1;
        `
);

export const Divider = styled.div(
    () =>
        css`
            width: 100%;
            height: 1px;
            margin: 58px 0;
            background-color: #d1d0cf;
        `
);

export const SectionWrapper = styled.div(
    ({ theme: { spacing } }) =>
        css`
            width: 100%;
            margin-top: ${spacing['24px']};
            display: flex;
        `
);

export const Section = styled.div(
    () =>
        css`
            display: block;
            width: 100%;
            align: center;
        `
);

export const LinkWrapper = styled.div(
    () =>
        css`
            display: block;
        `
);

export const SectionIcon = styled.div(
    ({ theme: { spacing } }) =>
        css`
            display: block;
            margin-right: ${spacing['24px']};
        `
);

export const IconAndHeadingWrapper = styled.div(
    () =>
        css`
            display: block;
        `
);

export const SectionHeading = styled.div(
    () =>
        css`
            display: flex;
            width: 100%;
            align: center;
        `
);

export const StyledButtonLinkWithIcon = styled(ButtonLinkWithIcon)(
    () =>
        css`
            text-decoration: none;
        `
);

export const StyledButton = styled(Button)(
    ({ theme: { spacing } }) =>
        css`
            padding: 0;
            margin-top: ${spacing['32px']};
        `
);

export const StyledLabelForSale = styled.label(
    ({ theme: { borderRadius } }) =>
        css`
            background-color: #fff;
            display: block;
            padding: 15px 16px;
            cursor: pointer;
            font-weight: bold;
            font-size: 13px;
            color: #595963;
            text-align: center;
            border-radius: ${borderRadius['4px']};
            position: absolute;
            top: 0px;
            left: 50%;

            &:hover {
                text-decoration: underline;
            }
        `
);

export const StyledLabelToRent = styled.label(
    ({ theme: { borderRadius } }) =>
        css`
            background-color: #fff;
            display: block;
            padding: 15px 16px;
            cursor: pointer;
            font-weight: bold;
            font-size: 13px;
            color: #595963;
            text-align: center;
            border-radius: ${borderRadius['4px']};
            position: absolute;
            top: 0px;
            left: 59%;

            &:hover {
                text-decoration: underline;
            }
        `
);

export const StyledInputToRent = styled.input(
    () =>
        css`
            position: absolute;
            opacity: 0;

            &:checked + label {
                background-color: #322744;
                color: #fff;
            }

            &:checked + label + ${SectionToRent} {
                display: block;
            }
        `
);

export const StyledInputForSale = styled.input(
    () =>
        css`
            position: absolute;
            opacity: 0;

            &:checked + label {
                background-color: #322744;
                color: #fff;
            }

            &:checked + label + ${SectionForSale} {
                display: block;
            }
        `
);

export const StyledTabsContainer = styled.div(
    () =>
        css`
            display: flex;
            flex-wrap: wrap;
        `
);

export const TabsWrapper = styled.div(
    () =>
        css`
            display: block;
        `
);

export const SectionToRent = styled.div(
    () =>
        css`
            display: none;
            min-width: 100%;
        `
);

export const SectionForSale = styled.div(
    () =>
        css`
            display: none;
            min-width: 100%;
        `
);
